module.exports = __webpack_public_path__ + "static/media/project6.6cde099e.png";